import { ReducerActionRotaSP } from 'store/modules/types';
import { ImprimirDareState, RequestImprimirDare, Types } from './types';

export function imprimirDareRequest(
	token: string,
	payload: RequestImprimirDare,
): ReducerActionRotaSP {
	return {
		type: Types.IMPRIMIR_DARE_REQUEST,
		token,
		payload,
	};
}
export function imprimirDareSuccess(
	payload: ImprimirDareState,
): ReducerActionRotaSP {
	return {
		type: Types.IMPRIMIR_DARE_SUCCESS,
		payload,
	};
}
export function imprimirDareFailure(): ReducerActionRotaSP {
	return {
		type: Types.IMPRIMIR_DARE_FAILURE,
		payload: null,
	};
}
export function imprimirDareClear(): ReducerActionRotaSP {
	return {
		type: Types.IMPRIMIR_DARE_CLEAR,
		payload: null,
	};
}
